export default __webpack_public_path__ + "static/media/bdx-stJean.da163efe.webp";